<template>
  <div
    v-bind="$attrs"
    class="skeleton"
    :style="setStyles"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    height: {
      type: [Number, String],
      default: 10,
    },
    width: {
      type: [Number, String],
      default: 10,
    },
    radius: {
      type: [Number, String],
      default: 4,
    },
  },
  computed: {
    setHeight() {
      return this.transformToRem(
        this.height,
      );
    },
    setWidth() {
      return this.transformToRem(
        this.width,
      );
    },
    setRadius() {
      return this.transformToRem(
        this.radius,
      );
    },
    setStyles() {
      return {
        width: this.setWidth,
        height: this.setHeight,
        'border-radius': this.setRadius,
      };
    },
  },
  methods: {
    transformToRem(num) {
      if (String(num).includes('%')) {
        return num;
      }
      return `${Number(num) / 16}rem`;
    },
  },
};
</script>

<style scoped>
  .skeleton{
    animation : shimmer 2s infinite;
    background: linear-gradient(to right, #d1d1d1 4%, #e2e2e2 25%, #d1d1d1 36%);
    background-size: 1000px 100%;
  }
  @keyframes shimmer {
    0% {
      background-position: -1000px 0;
    }
    100% {
      background-position: 1000px 0;
    }
  }
</style>
